import { useGraphQLQuery } from '@betterment/js-runtime';

import { FourOhOneKContributionsQueryResult } from './data';
import {
  FourOhOneKContributionsDocument,
  FourOhOneKContributionsQuery,
  FourOhOneKContributionsQueryVariables,
} from './graphql/query.fourOhOneKContributions.generated';

export const useFourOhOneKContributionsQuery = (): FourOhOneKContributionsQueryResult => {
  const { data } = useGraphQLQuery<FourOhOneKContributionsQuery, FourOhOneKContributionsQueryVariables>(
    FourOhOneKContributionsDocument,
    {
      variables: { location: 'goal_overview_four_oh_one_k_contributions' },
      throwOnError: true,
    }
  );

  const isLoading = !data;

  return {
    isLoading,
    employeeContributions: data?.fourOhOneKContributions,
    employers: data?.employers,
    messages: data?.messages,
  };
};
